import { io } from "socket.io-client";

export const nodeSocket = io({
  path: '/socket.io/',
  autoConnect: true,
  transports: ["websocket"],
  reconnection: true,
  reconnectionAttempts: 20,
  reconnectionDelay: 1500,
});
